








import Vue from "vue";

export default Vue.extend({
  name: "App",
  metaInfo: {
    title: "Welcome!",
    titleTemplate: "%s | GreenPlay",
  },
  mounted(): void {
    let vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty("--vh", `${vh}px`);
    window.addEventListener("resize", () => {
      let vh = window.innerHeight * 0.01;
      // Then we set the value in the --vh custom property to the root of the document
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    });
  },

  data: () => ({}),
});
